import styled from "styled-components";
import { Radio } from 'antd';

// Internal Imports
import { IFormQuestion } from "../../../interfaces/IForm";
import { COLORS } from "../../constants/colors";
import { PreguntaTipo } from "../../enums/AllEnums";
import MarginInput from "../MarginInput/MarginInput";
import SelectBox from "../SelectBox/SelectBox";
import { useState } from "react";


// Style
const Wrapper = styled.div`
    width: 97%;
    min-height: 100px;
    border-radius: 5px;
    background-color: ${COLORS.white_color2(1)};
    box-shadow: 0px 2px 1.5px ${COLORS.black_shadow_1};
    overflow: hidden;
    margin: 5px;
    margin-top: 10px;
    transition: .5s all;
    display: grid;
    grid-template-columns: auto 1fr;

    .rq-question-id {
        background-color: ${COLORS.blue_inactive(1)};
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rq-question-id label {
        text-align: center;
        color: ${COLORS.blue_main(1)};
        font-size: 1.2rem;
        min-width: 50px;
        font-weight: bold;
    }
    
    .rq-question-detail {
        padding: 10px 10px 5px 10px;
    }

    .rq_header {
        display: grid;
        grid-template-columns: 1fr auto;
        column-gap: 15px;
    }

     .rq_header label { 
        color: ${COLORS.blue_main(1)};
        font-size: 1.2rem;
     }

    .rq_question_option {
        display: grid;
        grid-template-columns: 1fr auto;
        column-gap: 15px;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .rq_question_option label {
        font-size: 1rem;
        font-weight: 300;
        color: ${COLORS.black_text_color1};
    }

    .rq_circle {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background-color: ${COLORS.blue_inactive(1)};
    }

    .rq_option_label {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        column-gap: 10px;
    }

    .rq_radio {
        /* position: absolute;
        bottom: 10px;
        right: 0px; */
        float: right;
        margin: 5px;
        color: ${COLORS.black_text_color1};
    }
`;

// Props
interface Props {
    question: IFormQuestion;
    index: number;
    method: (index: number, question: IFormQuestion) => void;
    orderList: number[];
    loading: boolean;
}

const RelatedQuestion = ({ question, index, method, orderList, loading }: Props) => {

    const handleSetNextQuestion = (next: number, optionId: number = 0) => {
        const questionClone = question;

        if (questionClone.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple) {

            questionClone.respuestaOpcion.forEach(option => {
                option.preguntaSiguienteID = next || null;
            })

        } else if (questionClone.preguntaTipoNombre === PreguntaTipo.Seleccion) {

            questionClone.respuestaOpcion[optionId].preguntaSiguienteID = next || null;

        } else {

            questionClone.respuestaOpcion[0].preguntaSiguienteID = next || null;
        }

        method(index, questionClone);
    }

    return (
        <Wrapper>
            <div className="rq-question-id">
                <label>{question.preguntaID}</label>
            </div>

            <div className="rq-question-detail">

                <div className="rq_header">
                    <label>
                        {question.pregunta}
                    </label>

                    {question.respuestaOpcion.length === 1 || question.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple
                        ?
                        <SelectBox
                            value={question.respuestaOpcion[0].preguntaSiguienteID}
                            height={'30px'}
                            placeholder={"Siguiente"}
                            disabled={loading}
                            allowClear={true}
                            loading={false}
                            onChange={(value: string) => handleSetNextQuestion(parseInt(value))}
                            options={orderList.map(order => ({ key: 'op' + order, value: order.toString(), text: order.toString() }))}
                            backgroundColor={COLORS.transparent_color1}
                            borderColor={COLORS.blue_main(1)}
                            textColor={COLORS.blue_main(1)}
                        />
                        :
                        <></>
                    }
                </div>

                {question.respuestaOpcion.length > 1 &&
                    question.respuestaOpcion.map((item, indexOption) => (
                        <div className="rq_question_option">
                            <div className="rq_option_label">
                                <div className="rq_circle"></div>
                                <label>{item.respuesta}</label>
                            </div>
                            {question.preguntaTipoNombre !== PreguntaTipo.SeleccionMultiple &&
                                <MarginInput width="100%">
                                    <SelectBox
                                        value={item.preguntaSiguienteID}
                                        height={'30px'}
                                        placeholder={"Siguiente"}
                                        disabled={loading}
                                        allowClear={true}
                                        loading={false}
                                        onChange={(value: string) => handleSetNextQuestion(parseInt(value), indexOption)}
                                        options={orderList.map(order => ({ key: 'op' + order, value: order.toString(), text: order.toString() }))}
                                        backgroundColor={COLORS.transparent_color1}
                                        borderColor={COLORS.blue_main(1)}
                                        textColor={COLORS.blue_main(1)}
                                    />
                                </MarginInput>
                            }
                        </div>
                    ))
                }

                <Radio className="rq_radio" value={index}>¿Es la principal?</Radio>
            </div>
        </Wrapper>
    );
}

export default RelatedQuestion;